import featureFlags from 'shared/lib/featureFlags';

/* eslint no-console:0 */
export default () => (type, event, skip) => {
  if (!featureFlags.logger) {
    return;
  }

  const titleArgs = [`%c WS event: ${type}${skip ? ' (SKIPPED)' : ''}`, 'color: blue'];
  console.group(...titleArgs);
  console.log(event);
  console.groupEnd(...titleArgs);
};
